//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SearchByLeagueOrVenue = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [loadedTeams, setLoadedTeams] = useState()
	const [loadedVenues, setLoadedVenues] = useState()
	const [error, setError] = useState()

	let selectedLeague, selectedTeam, selectedVenue

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues])

	let leagueArray

	if (loadedLeagues && !isLoading) {
		leagueArray = []
		loadedLeagues.forEach((league) => {
			const leagueDisplay =
				league.leagueName + ' - ' + league.session + ' ' + league.year
			leagueArray.push(leagueDisplay)
		})
	}
	//
	//
	//
	//
	//
	//Call backend to get all the current TEAMS for our dropdown
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.currentTeamsArray)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [setLoadedTeams])

	let teamArray

	//loadedTeams && console.log('loadedTeams: ' + loadedTeams)

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team.leagueName + ' --> ' + team.teamName)
		})
	}
	//
	//
	//
	//Call backend to get all the current VENUES for our dropdown
	useEffect(() => {
		const sendRequest3 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/venues'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error('error message: ' + responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setLoadedVenues(responseData.allVenues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest3()
	}, [setLoadedVenues])

	let venueArray

	if (loadedVenues && !isLoading) {
		venueArray = []
		loadedVenues.forEach((venue) => {
			//const teamDisplay = team
			venueArray.push(venue.venueName)
		})
	}

	let navigate = useNavigate()
	//For handling a search by team request:
	const handleChange1 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedTeam = loadedTeams[selectedValue]
		const teamId = selectedTeam._id
		const leagueName = selectedTeam.leagueName
		const session = selectedTeam.session
		const year = selectedTeam.year
		const teamName = selectedTeam.teamName
		//navigate(`/league/teamSchedule/${teamId}`)
		navigate(
			`/league/teamSchedule/${leagueName}/${session}/${year}/${teamName}`
		)
	}

	//For handling a search by league request:
	const handleChange = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedLeague = loadedLeagues[selectedValue]
		const leagueId = selectedLeague._id
		navigate(`/league/schedule/${leagueId}`)
	}

	//For handling a search by VENUE request
	const handleChange3 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedVenue = loadedVenues[selectedValue]
		const venueId = selectedVenue._id
		navigate(`/league/${venueId}/schedule`) //< - - - should go to VenueSchedule
	}

	return (
		<React.Fragment>
			{/* <Card> */}
			<div className='searchbyleagueorvenue'>
				<div className='row'>
					<div className='LTVinstructions'>Search by Team or League: </div>
				</div>
				{!isLoading && loadedTeams && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							{/* <form className='form-control-lg'> */}
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselector'
									// className='my-1 mr-sm-2 scheduleselector'
									onChange={handleChange1}
								>
									<option defaultValue>Team....</option>
									{teamArray.map((team, i) => (
										<option value={i} key={i}>
											{team.toUpperCase()}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
				{!isLoading && loadedLeagues && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							{/* <form className='form-control-lg'> */}
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								<select
									className='scheduleselector'
									// className='my-1 mr-sm-2 scheduleselector'
									onChange={handleChange}
								>
									<option defaultValue>League....</option>
									{leagueArray.map((league, i) => (
										<option value={i} key={i}>
											{league.toUpperCase()}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div>
				)}
			</div>
			{/* {!isLoading && loadedVenues && (
				<div className='row'>
					<div className='col'></div>
					<div className='col-sm'>
						<form className='dropdownForm' style={{ textAlign: 'center' }}>
							<select className='scheduleselector' onChange={handleChange3}>
								<option defaultValue>Venue....</option>
								{venueArray.map((venue, i) => (
									<option value={i} key={i}>
										{venue}
									</option>
								))}
							</select>
						</form>
					</div>
					<div className='col'></div>
				</div>
			)} */}
		</React.Fragment>
	)
}

export default SearchByLeagueOrVenue
